import { useEffect, useState } from "react"
import { SearchBookSourceUsedOnlineResponse } from "../SearchBookSourceUsedResponse"
import { BooksitoutServer } from "../../../../config/BooksitoutServer"

const useBookUsedOnline = (isbn13: string) => {
    const [books, setBooks] = useState<SearchBookSourceUsedOnlineResponse[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)

    useEffect(() => {
        if (isbn13 !== '') {
            BooksitoutServer
                .get(`/v1/book/search/sources/used/online?isbn13=${isbn13}`)
                .then((res) => setBooks(res.data))
                .finally(() => setIsLoading(false))
        }
    }, [isbn13])

    return [books, isLoading] as const
}

export default useBookUsedOnline
